<script>
    import { fly } from 'svelte/transition';
    export let marginTop=0;
    export let container=true;
</script>

{#if container}
    <div class="container-fluid mt-{marginTop}" in:fly={{x:-1000}}>
        <slot/>
    </div>
{:else}
    <div class="mt-{marginTop}" in:fly={{x:-1000}}>
        <slot/>
    </div>
{/if}
